import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Module } from '@shared/models';
import { ModuleHasClientAccessPipe } from '@shared/pipes';
import { UserDetailsFacade } from '@shared/state/facades';
import { take, tap, withLatestFrom } from 'rxjs';

@UntilDestroy()
@Injectable()
export class ModuleNavigationService {
  userDetails$ = this.userDetailsFacade.query.userDetails$;
  selectedClient$ = this.userDetailsFacade.query.selectedClient$;

  coreModule: typeof environment.coreModule = environment.coreModule;
  myAccountPath = '/my-profile/account';

  constructor(
    private userDetailsFacade: UserDetailsFacade,
    private moduleHasClientAccessPipe: ModuleHasClientAccessPipe
  ) {}

  navigateToModule(
    module: Module,
    path: string = null,
    openInNewTab: boolean = true
  ): void {
    this.userDetails$
      .pipe(
        untilDestroyed(this),
        withLatestFrom(this.selectedClient$),
        take(1),
        tap(([userDetails, selectedClient]) => {
          let locationUrl = `${module.locationUrl}`;

          if (path) {
            locationUrl += path;
          }

          const clientId = userDetails?.selectedClientId;
          if (clientId != null && !locationUrl.includes(clientId)) {
            locationUrl += `?clientId=${clientId}`;
          }

          if (
            module.name !== environment.coreModule.name &&
            !this.moduleHasClientAccessPipe.transform(
              module,
              userDetails.accountType,
              selectedClient.modules
            )
          ) {
            locationUrl = module.landingPageUrl;
          }

          const target =
            locationUrl.indexOf(window.location.origin) > -1 || !openInNewTab
              ? '_self'
              : '_blank';

          window.open(locationUrl, target);
        })
      )
      .subscribe();
  }

  navigateToCore(path: string = null, openInNewTab: boolean = true): void {
    this.navigateToModule(this.coreModule, path, openInNewTab);
  }

  navigateToMyAccount(openInNewTab: boolean = true): void {
    this.navigateToCore(this.myAccountPath, openInNewTab);
  }
}
